import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss']
})
export class PaymentStatusComponent implements OnInit {

  chartOpts:any;
  chartData:any;
 

  constructor() { }

  ngOnInit() {

    this.chartData =[
      ['Task', 'Hours per Day'],
      ['Work',     11],
      ['Eat',      2],
      ['Commute',  2],
      ['Watch TV', 2],
      ['Sleep',    7]
    ];
   


    this.chartOpts = {
      chartType: 'PieChart',
      options: {'title': 'Payment Status'}
    };
  }

}
